exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lab__lab__3cEc4KfWgS {\r\n    height: 100%;\r\n}", ""]);

// exports
exports.locals = {
	"lab": "lab__lab__3cEc4KfWgS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:10]"}!./src/components/labs/lab.css
// module id = 41
// module chunks = 0